// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__1Md9b"};